import React from 'react';
import { mergeSx } from '@cp/ds/src/utils/sx/merge';
import { Stack } from '@cp/ds/src/components/stack';
import { CatalogNavViewProps } from './model';

const ViewDesktop: React.FC<CatalogNavViewProps> = ({ sx, citySearchFormField }) => {
  const containerSx = React.useMemo(
    () =>
      mergeSx(
        {
          width: '100%',
          alignItems: 'flex-start',
        },
        sx,
      ),
    [sx],
  );

  return (
    <Stack component="form" gap={1.5} noValidate sx={containerSx}>
      {citySearchFormField}
    </Stack>
  );
};

export default ViewDesktop;
